module.exports = __webpack_public_path__ + "img/tractorUnitFrontLeftOutline.40c29144.svg";